import { useState, useCallback } from 'react';
import {
    Text,
    Card,
    CardHeader,
    makeStyles,
    Divider,
    Accordion,
    AccordionItem,
    AccordionHeader,
    AccordionPanel,
    AccordionToggleEventHandler,
    tokens,
} from '@fluentui/react-components';
import { AgentFaq } from '../../../../domain/agents/models/Agent';
import useOverviewStyles from '../styles/AgentOverviewStyles';
import { Add20Filled, Dismiss20Filled } from '@fluentui/react-icons';
import { customColors } from '../../../../styles';

const useStyles = makeStyles({
    accordion: {
        width: '100%',
    },
    accordionHeader: {
        color: customColors.protivitiOrange,
    },
    faqQuestionText: {
        paddingBlock: '4px',
        fontSize: '1.2rem',
        lineHeight: 1.6,
        fontWeight: tokens.fontWeightSemibold,
    },
    accordionPanel: {
        paddingBlock: '8px 24px',
        color: customColors.summarizeButtonHoverLighter,
    },
    faqAnswerText: {
        fontSize: '1rem',
    },
});

interface FAQsCardProps {
    faqs: AgentFaq[] | undefined;
}

const FAQsCard: React.FC<FAQsCardProps> = ({ faqs }) => {
    const styles = useStyles();
    const overviewStyles = useOverviewStyles();

    const [openFAQItems, setOpenFAQItems] = useState<string[]>([]);

    const handleToggle = useCallback<AccordionToggleEventHandler>((_, data) => {
        setOpenFAQItems((data.openItems as (string | number)[]).map(String));
    }, []);

    return (
        <Card className={overviewStyles.card}>
            <CardHeader
                className={overviewStyles.cardHeader}
                header={
                    <header className={overviewStyles.header}>
                        <Text className={overviewStyles.headerTitle}>Frequently Asked Questions</Text>
                        <Divider />
                    </header>
                }
            />

            <Accordion
                collapsible
                multiple
                onToggle={handleToggle}
                openItems={openFAQItems}
                className={styles.accordion}
            >
                {faqs?.map((faq, index) => (
                    <AccordionItem key={index} value={index.toString()}>
                        <AccordionHeader
                            expandIconPosition="end"
                            expandIcon={openFAQItems.includes(index.toString()) ? <Dismiss20Filled /> : <Add20Filled />}
                            className={styles.accordionHeader}
                        >
                            <Text className={styles.faqQuestionText}>{faq.question}</Text>
                        </AccordionHeader>
                        <AccordionPanel className={styles.accordionPanel}>
                            <Text className={styles.faqAnswerText}>{faq.answer}</Text>
                        </AccordionPanel>
                        <Divider />
                    </AccordionItem>
                ))}
            </Accordion>
        </Card>
    );
};

export default FAQsCard;
